













import {Component, Mixins} from 'vue-property-decorator';
import ActionModal from '@/layouts/back-office/elements/actions/ActionModal.vue';
import ActionMixin from '@/layouts/back-office/elements/actions/ActionMixin';
import AuctionTypeSelect from '@/components/auction/input/AuctionTypeSelect.vue';
import {AuctionList, MarkAuctionAsPaidVariables} from '@/types/auction';
import Input from '@/components/elements/input/Input.vue';
import InputTextarea from '@/layouts/back-office/elements/input/InputTextarea.vue';

@Component({
  components: {InputTextarea, Input, AuctionTypeSelect, ActionModal},
})
export default class MarkAuctionAsPaidAction extends Mixins(ActionMixin) {
  protected auction: AuctionList | null = null;

  public open(auction: AuctionList) {
    this.auction = auction;

    const modal: ActionModal = this.$refs.actionModal as ActionModal;

    modal.open();
  }

  protected get MarkAuctionAsPaidVariables(): MarkAuctionAsPaidVariables | null {
    if (!this.auction) {
      return null;
    }

    return {
      id: this.auction.id,
    };
  }
}
